import { render, staticRenderFns } from "./EssentialsPLP.vue?vue&type=template&id=2150c2e4&"
import script from "./EssentialsPLP.vue?vue&type=script&lang=js&"
export * from "./EssentialsPLP.vue?vue&type=script&lang=js&"
import style0 from "./EssentialsPLP.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports